import React from "react";

import { FixedNameCell } from ".";
import Icon from "../../../../../../../Common/DesignSystem/Icons/Icon";
import colours from "../../../../../../../Common/DesignSystem/Colours";
import { Tooltip, TooltipTrigger, TooltipContent } from "../../../../../../../Common/Tooltip";

const ConvertInventoryIntoVehicleButton = ({ vehicleId, convertInventoryIntoVehicle }) => (
    <Tooltip open={vehicleId ? undefined : false}>
        <TooltipTrigger
            className="convert-into-vehicle-btn"
            onClick={convertInventoryIntoVehicle}
            style={vehicleId ? { backgroundColor: colours.accent.validate_green, borderColor: colours.accent.validate_green } : {}}
        >
            {vehicleId ? (
                <Icon name="Vehicle" size={16} style={{ color: '#FFF', margin: '0 14px' }} />
            ) : (
                <>
                    <Icon name="Order" size={16} style={{ color: colours.primary.medBlue }} />
                    <Icon name="ChevronRight" size={8} style={{ color: colours.primary.grey03, margin: '0 2px' }} />
                    <Icon name="Vehicle" size={16} style={{ color: colours.primary.blue }} />
                </>
            )}
        </TooltipTrigger>

        <TooltipContent className="vehicle-icon-tooltip">
            View inventory
        </TooltipContent>
    </Tooltip>
);

export const InventoryNameCell = ({ vehicle, history }) => {
    const { id, orderNo, vehicleId, vehicleType, vehicleInfo } = vehicle;
    const isLinked = vehicle.metadata?.createdBy === 'system';

    const editInventory = () => {
        if (isLinked) return;

        window.location.assign(`/vehicleoverview/order/edit/${id}`);
    }

    const convertInventoryIntoVehicle = () => {
        if (vehicleId) {
            const legacyApiVehicleId = vehicle.additionalData.find(({ name }) => name === 'legacyApiVehicleId')?.value;
            if (legacyApiVehicleId) window.location.assign(`/vehicleoverview/vehicle/${legacyApiVehicleId}/Overview/${vehicleId}`);
            return;
        };

        window.location.assign(`/vehicleoverview/order/convert/${vehicle.id}`);
    }

    return (
        <FixedNameCell vehicle={vehicle} orderNo={orderNo}>
            <div className="vehicle-name" onClick={editInventory} style={{ cursor: isLinked ? 'default' : 'pointer' }}>
                {vehicleInfo?.year} {vehicleInfo?.make} {vehicleType} {vehicleInfo?.trim}
            </div>

            <ConvertInventoryIntoVehicleButton vehicleId={vehicleId} convertInventoryIntoVehicle={convertInventoryIntoVehicle} />
        </FixedNameCell>
    )
};
